import React from "react";

const AdvancedManagementBoxTimeDate = props => (
  <>
    {props.screen == "mobile" &&
      <div className="hidden-lg">
        <div className="row offers-divider offers-divider--title advanced-management-documents-sent--divider-margin" />
        <div className="text-left advanced-management-documents-sent--box--info-date-time">
          <p className="advanced-management-documents-sent--box--info-date-time-text"><strong>{props.date} <span>•</span> {props.time}</strong></p>
        </div>
      </div>
    }
    {props.screen == "desktop" &&
      <div className="col-xs-16 col-lg-4 text-left advanced-management-documents-sent--box--info-name hidden-xs hidden-sm hidden-md">
        <div className="d-flex flex-row advanced-management-documents-sent--box--info-date-time advanced-management-documents-sent--box--info-name-align-items-baseline">
          <p className="advanced-management-documents-sent--box--info-date-time-text no-margin">Data do envio para análise</p>
          <p className="advanced-management-documents-sent--box--info-date-time-text"><strong>{props.date} <span>•</span> {props.time}h</strong></p>
        </div>
      </div>
    }
  </>
);

export default AdvancedManagementBoxTimeDate;